import { Base } from "@app/controllers/base";
import moment from "moment"

export default class extends Base {
  static values = {
    datetime: String,
    refreshInterval: { type: Number, default: 60000 } // Refresh every 1 minute
  }

  connect() {
    this.update()
    this.timer = setInterval(() => {
      this.update()
    }, this.refreshIntervalValue)
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  update() {
    if (this.datetimeValue) {
      this.element.textContent = moment(this.datetimeValue).fromNow()
    }
  }
}
